import { render } from "./EmailLanguageSelector.vue?vue&type=template&id=dde052e4&scoped=true"
import script from "./EmailLanguageSelector.vue?vue&type=script&lang=js"
export * from "./EmailLanguageSelector.vue?vue&type=script&lang=js"

import "./EmailLanguageSelector.vue?vue&type=style&index=0&id=dde052e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dde052e4"]])

export default __exports__